<template>
  <div class="component-enotas">
    <div class="breadcrumbs d-flex align-items-center font-weight-bold mb-9">
      <router-link :to="{ name: 'home' }" class="text-secondary"
        >Início</router-link
      >
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link :to="{ name: 'tools' }" class="text-secondary">
        Ferramentas
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link :to="{ name: 'tools-invoices' }" class="text-secondary">
        Notas fiscais
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      eNotas
    </div>

    <h6 class="d-none d-lg-block">eNotas</h6>
    <div class="row align-items-center mb-5 pt-6">
      <div class="col-lg-3 mb-3">
        <div class="d-flex align-items-center">
          <div class="mr-5">Integrações</div>
          <button
            class="btn btn-sm btn-outline-primary btn-square-sm p-5"
            @click="dispatch"
          >
            <i class="icon-refresh-ccw" />
          </button>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="d-flex algn-items-center justify-content-end">
          <button
            type="button"
            class="btn btn-primary px-5 px-lg-6"
            @click="modal = true"
          >
            <span class="d-none d-lg-inline">
              Adicionar
            </span>
            <i class="icon-plus d-lg-none lead"></i>
          </button>
        </div>
      </div>
    </div>
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <div
        v-if="!integrationList.length"
        class="container centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block my-9 mx-auto"
              src="@/assets/images/home/welcome.svg"
            />
            <h5>Você ainda não adicionou nenhuma integração</h5>
            <div class="text-secondary mb-5">
              Clique no botão acima para cadastrar
            </div>
          </div>
        </div>
      </div>
      <!-- Desktop area -->
      <div v-else>
        <data-table
          class="d-none d-lg-block"
          :columns="columns"
          :data="integrationList"
          columnsFr="1fr 1fr 0.7fr 1fr 0.4fr 0.3fr"
        >
          <template #default="{ item }">
            <small class="d-flex align-items-center pr-3">
              {{ productName(item) }}
            </small>
            <small class="d-flex align-items-center pr-3">
              {{ nfeOptions[item.when_generate_nfe] }}
            </small>
            <small class="d-flex align-items-center">
              <strong
                :class="
                  item.send_nfe_for_client ? 'text-success' : 'text-danger'
                "
                >{{ item.send_nfe_for_client ? "Ativo" : "Inativo" }}</strong
              >
            </small>
            <small class="d-flex align-items-center">
              <strong :class="getStatusColor(item.status)">{{
                getStatusMessage(item.status)
              }}</strong>
            </small>
            <small class="d-flex align-items-center">
              <strong
                :class="item.is_enable ? 'text-success' : 'text-danger'"
                >{{ item.is_enable ? "Ativo" : "Inativo" }}</strong
              >
            </small>
            <div class="d-flex align-items-center justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @change-status="changeStatus(item)"
                @delete="submitDelete(item)"
                @edit="edit(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- Desktop area -->
        <!-- Mobile area -->
        <data-table
          class="d-lg-none"
          :columns="columns.slice(0, 2).map(d => '')"
          :data="integrationList"
          :firstColumnFr="2"
          :lastColumnFr="0.5"
        >
          <template #default="{ item }">
            <div class="d-flex flex-column text-left pl-3 py-5">
              <small class="d-flex align-items-center">
                <strong class="mr-3">Produto: </strong>
                {{ productName(item) }}
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">Quando emitir nota: </strong>
                {{ nfeOptions[item.when_generate_nfe] }}
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">Envio ao cliente: </strong>
                <strong
                  :class="
                    item.send_nfe_for_client ? 'text-success' : 'text-danger'
                  "
                  >{{ item.send_nfe_for_client ? "Ativo" : "Inativo" }}</strong
                >
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">Status na plataforma: </strong>
                <strong :class="getStatusColor(item.status)">{{
                  getStatusMessage(item.status)
                }}</strong>
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">Status: </strong>
                <strong
                  :class="item.is_enable ? 'text-success' : 'text-danger'"
                  >{{ item.is_enable ? "Ativo" : "Inativo" }}</strong
                >
              </small>
            </div>
            <div class="d-flex justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @change-status="changeStatus(item)"
                @edit="edit(item)"
                @delete="submitDelete(item)"
              />
            </div>
          </template>
        </data-table>
      </div>
      <!-- Mobile area -->
      <div v-if="integrationList.length" class="d-flex justify-content-center">
        <paginator :pagination="pagination" @on-update="dispatch" />
      </div>
    </div>
    <enotas-modal
      v-model="modal"
      :integrationToEdit="integrationToEdit"
      @clear-edit="integrationToEdit = null"
      @update-list="dispatch"
    />
  </div>
</template>
<script>
import enotasModal from "@/components/tools/modals/ENotas.vue";
import IntegrationsMixin from "@/mixins/integration.js";
import get from "lodash/get";
import { mapState } from "vuex";
export default {
  mixins: [IntegrationsMixin],
  components: {
    enotasModal
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
  },
  data() {
    return {
      integration: "enotas",
      integrationToEdit: null,
      columns: [
        "Produto",
        "Quando emitir nota",
        "Envio ao cliente",
        "Status na plataforma",
        "Status",
        ""
      ],
      nfeOptions: [
        "Emitir nota no ato da venda",
        "Emitir nota depois quando garantia acabar",
        "Não emitir a nota"
      ],
      loading: false,
      modal: false,
      search: ""
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["integrationList", "pagination"])
  },
  methods: {
    getStatusColor(status) {
      const colorMap = {
        enable: "text-success",
        review: "text-warning",
        disable: "text-danger",
        fail: "text-danger"
      };
      return colorMap[status];
    },
    getStatusMessage(status) {
      const messageMap = {
        enable: "Ativo",
        review: "Em revisão",
        disable: "Inativo",
        fail: "Token inválido"
      };
      return messageMap[status];
    },
    productName(item) {
      return get(
        this.products.find(p => p.id === item.product_id),
        "name",
        "-"
      );
    },
    getActions(item) {
      return [
        {
          text: item.is_enable ? "Desativar" : "Ativar",
          class: item.is_enable ? "text-danger" : "text-success",
          icon: "icon-power",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "change-status"
        },
        {
          text: "Editar",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "edit"
        },
        {
          text: "Remover",
          class: "text-danger",
          icon: "icon-trash",
          confirmation: {
            enable: true,
            text: "Deseja mesmo remover esta integração?"
          },
          event: "delete"
        }
      ];
    },
    dispatch() {
      this.$store.dispatch("product/get", { limit: 500 });

      let params = { search: this.search };

      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", params)
        .catch(error => {
          this.$message.error("Não foi possível carregar as contas integradas");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      let data = item;
      data.is_enable = !item.is_enable;
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success(
            `Integração ${data.is_enable ? "ativada" : "desativada"}`
          );
        })
        .catch(() => {
          this.$message.error(
            "Não foi possível alterar o status da integração"
          );
        });
    }
  }
};
</script>
<style></style>
